// extracted by mini-css-extract-plugin
export default {"root":"zJ7nMSFCzzBEtJZUZy3l","placeHolderShimmer":"ikmpRvAcvzh2GVMSohkd"};